<template>
    <div class="modal-content px-4">
        <div class="modal-header justify-content-center border-0">
            <div class="d-flex flex-column justify-content-center align-items-center" style="color: #137FEC;">
                <div class="mt-4" style="width: 60px; height: 60px; padding: 14px; background: #E7F2FD; border-radius: 90em; ">
                    <svg width="100%" height="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M15.625 17.5H11.7609C12.411 16.9205 13.0242 16.3008 13.5966 15.6445C15.7413 13.178 16.875 10.5779 16.875 8.125C16.875 6.30164 16.1507 4.55295 14.8614 3.26364C13.572 1.97433 11.8234 1.25 10 1.25C8.17664 1.25 6.42795 1.97433 5.13864 3.26364C3.84933 4.55295 3.125 6.30164 3.125 8.125C3.125 10.5779 4.25865 13.178 6.40335 15.6445C6.97585 16.3008 7.58896 16.9205 8.23908 17.5H4.375C4.20924 17.5 4.05027 17.5658 3.93306 17.6831C3.81585 17.8003 3.75 17.9592 3.75 18.125C3.75 18.2908 3.81585 18.4497 3.93306 18.5669C4.05027 18.6842 4.20924 18.75 4.375 18.75H15.625C15.7908 18.75 15.9497 18.6842 16.0669 18.5669C16.1842 18.4497 16.25 18.2908 16.25 18.125C16.25 17.9592 16.1842 17.8003 16.0669 17.6831C15.9497 17.5658 15.7908 17.5 15.625 17.5ZM10 5.625C10.4945 5.625 10.9778 5.77162 11.3889 6.04633C11.8001 6.32103 12.1205 6.71148 12.3097 7.16829C12.4989 7.62511 12.5484 8.12777 12.452 8.61273C12.3555 9.09768 12.1174 9.54314 11.7678 9.89277C11.4182 10.2424 10.9727 10.4805 10.4877 10.577C10.0028 10.6734 9.50013 10.6239 9.04331 10.4347C8.5865 10.2455 8.19605 9.92505 7.92135 9.51393C7.64664 9.1028 7.50002 8.61945 7.50002 8.125C7.50002 7.79669 7.56468 7.4716 7.69031 7.16829C7.81595 6.86497 8.0001 6.58937 8.23225 6.35723C8.46439 6.12508 8.73999 5.94093 9.04331 5.8153C9.34662 5.68966 9.67171 5.625 10 5.625Z"
                            fill="currentColor" />
                    </svg>
                </div>
                <h5 class="mt-3">{{ $t('complete_your_profile_title') }}</h5>
                <div class="form-group">
                    <p class="text-center" style="color: #070A28;" v-html="$t('complete_your_profile_text')"></p>
                </div>
            </div>
        </div>
        <div class="modal-body">

            <div class="form-group m-0">
                <label class="mb-1">{{ `${$t('province')}*` }}</label>
                <ito-select v-model="models.province" :options="provinceOptions" valueKey="id" labelKey="name" value-format="object" :placeholder="$t('choose_province')" :searchable="true" />
            </div>
            <div class="form-group">
                <label class="mb-1">{{ `${$t('ward')}*` }}</label>
                <ito-select v-model="models.ward" :options="wardOptions" valueKey="id" labelKey="name" value-format="object" :placeholder="$t('choose_ward')" :searchable="true" />
            </div>
            <div class="form-group">
                <label class="form-label mb-1 required">{{ `${$t('school')}*` }}</label>
                <input type="text" class="form-control" v-model="models.school_name" :placeholder="$t('input_school_name')">
            </div>
            <div class="form-group">
                <label class="form-label mb-1 required">{{ `${$t('class')}*` }}</label>
                <input type="text" class="form-control" v-model="models.class_name" :placeholder="$t('input_class_name')">
            </div>
            <div class="form-group" v-if="errors.message">
                <small class="text-danger mt-3">{{ errors.message }}</small>
            </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
            <button type="button" class="ito-btn ito-btn-lg ito-btn-primary m-auto mb-3" :disabled="isDisabled" @click="save()">{{ $t('update_location') }}</button>
        </div>
    </div>
</template>

<script>
import ItoSelect from '@/components/common/ItoSelect.vue';
import { updateAddress } from '@/models/profile';

export default {
    name: "UpdateAddressModal",
    components: { ItoSelect },
    data() {
        return {
            provinceOptions: [],
            wardOptions: [],
            models: {
                province: null,
                ward: null,
                school_name: '',
                class_name: ''
            },
            errors: {
                message: null,
            }
        }
    },

    computed: {
        user_info() {
            return this.$store.state.user_info;
        },
        configs() {
            return this.$store.state.configs
        },
        isDisabled() {
            return !this.models.province || !this.models.ward || this.models.school_name == '' || this.models.class_name == '';
        }
    },

    watch: {
        configs: {
            handler(cfg) {
                this.provinceOptions = cfg?.provinces || [];
            },
            immediate: true,
            deep: true
        },

        user_info: {
            handler(u) {
                if (!u) return;
                this.models.province = this.provinceOptions.find(p => p.id === u.province?.id) || null;
                this.models.ward = u.ward || null;
                this.models.school_name = u.school;
                this.models.class_name = u.class;
            },
            immediate: true,
            deep: true
        },

        'models.province': {
            handler(value) {
                this.wardOptions = value?.Ward || [];
                if (!this.wardOptions.find(w => w.id === this.models.ward?.id)) {
                    this.models.ward = null;
                }
            },
            immediate: true
        }
    },

    methods: {
        save() {
            if (this.models.province && this.models.ward) {
                this.$store.commit("setLoading", true);
                updateAddress({
                    province_id: this.models.province.id,
                    ward_id: this.models.ward.id,
                    school_name: this.models.school_name,
                    class_name: this.models.class_name
                }).then((response) => {
                    if (response.data.code != 0) {
                        this.errors.message = response.data.msg
                        return;
                    } else {
                        this.$store.dispatch('SET_USER_INFO')
                        this.$emit('resolve')
                    }
                }).catch(({ response }) => {
                    this.errors.message = response.error.message
                    console.error(response);
                }).finally(() => {
                    this.$store.commit("setLoading", false);
                });
            }
        }

    }
}
</script>

<style scoped>
.modal-content {
    color: #151522;
    font-size: medium;
    border-radius: 16px;
    box-shadow: 0px 4px 0px 0px #E7E7E740 inset, 4px 4px 0px 0px #00000012;
}
</style>